import React from 'react';
import { useRecordContext } from 'react-admin';
import { ContactShareButtons } from './ContactShareButtons.tsx';

type ContactRecord = {
  id?: number;
  firstName?: string;
  lastName?: string;
};

// Same Download and Share as the list, scoped to the contact that is open.
export const ShareContactButton: React.FC = () => {
  const record = useRecordContext<ContactRecord>();

  if (!record?.id) return null;

  const fullName = `${record.firstName ?? ''} ${record.lastName ?? ''}`.trim();
  const slug = fullName.replace(/[^a-z0-9]+/gi, '-').toLowerCase() || String(record.id);

  return (
    <ContactShareButtons
      filter={{}}
      ids={[record.id]}
      scopeLabel=""
      filename={`contact-${slug}.csv`}
      dialogHeading="Share Contact"
      defaultSubject={fullName ? `Contact: ${fullName}` : 'Contact'}
      defaultMessage={
        fullName ? `Here is ${fullName}'s contact information.` : 'Here is the contact information.'
      }
      successMessage="Contact sent"
      size="small"
      variant="outlined"
    />
  );
};
